var map = {
	"./logo-alphabet.svg": 5037,
	"./logo-amazon-2.svg": 5038,
	"./logo-amazon.svg": 5039,
	"./logo-azercell.svg": 5040,
	"./logo-bank-of-america.svg": 5041,
	"./logo-barclays.svg": 5042,
	"./logo-bbc.svg": 5043,
	"./logo-bnp-paribas.svg": 5044,
	"./logo-booking.svg": 5045,
	"./logo-citibank.svg": 5046,
	"./logo-coca-cola.svg": 5047,
	"./logo-deloitte.svg": 5048,
	"./logo-experian.svg": 5049,
	"./logo-facebook.svg": 5050,
	"./logo-g.svg": 5051,
	"./logo-goldman-sachs.svg": 5052,
	"./logo-google.svg": 5053,
	"./logo-h.svg": 5054,
	"./logo-henkel.svg": 5055,
	"./logo-hsbc.svg": 5056,
	"./logo-ikea.svg": 5057,
	"./logo-infineon.svg": 5058,
	"./logo-instagram.svg": 5059,
	"./logo-jp-morgan.svg": 5060,
	"./logo-jti.svg": 5061,
	"./logo-linkedin.svg": 5062,
	"./logo-meta.svg": 5063,
	"./logo-morgan-stanley.svg": 5064,
	"./logo-netflix.svg": 5065,
	"./logo-oracle.svg": 5066,
	"./logo-paypal.svg": 5067,
	"./logo-pwc-new.svg": 5068,
	"./logo-pwc.svg": 5069,
	"./logo-spotify.svg": 5070,
	"./logo-tesla.svg": 5071,
	"./logo-visa.svg": 5072,
	"./logo-walmart.svg": 5073,
	"./logo-youtube.svg": 5074
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5036;